module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/airstrike-elite.1f851335.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/airstrike-elite.png
// module id = 3695
// module chunks = 11